import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://frontech-consulting.com';
const DEFAULT_OG = `${SITE_URL}/og-image.png`;

/**
 * Per-route SEO metadata. Overrides the agency defaults declared in
 * public/index.html. Baked into each route's static HTML by react-snap
 * at build time, so bots and social scrapers see per-page content.
 */
export default function Seo({
  title,
  description,
  path = '/',
  image = DEFAULT_OG,
  type = 'website',
  noindex = false,
}) {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:site_name" content="FRONTECH" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
